import { Dimmer, Loader } from "semantic-ui-react";
import { VolumeAndCost } from "../../../../components";

import {
  useCreateVolumeAndCost,
  useDeleteVolumeAndCost,
  useGetVolumeAndCost,
  useUpdateVolumeAndCost
} from "../../../../api/volumeAndCost";
import { successMessage } from "../../../../helpers/ErrorHandler";

interface ProductVolumeAndCostProps {
  productId: string;
  salesUnitId: string;
  unitSize?: number;
  unitType?: string;
}

const ProductVolumeAndCost = ({ productId, salesUnitId, unitSize = 1, unitType = 'kg' }: ProductVolumeAndCostProps) => {
  const { data: volumeAndCost, isLoading, refetch } = useGetVolumeAndCost(productId, salesUnitId);
  const { mutate: createVolumeAndCost } = useCreateVolumeAndCost();
  const { mutate: updateVolumeAndCost } = useUpdateVolumeAndCost();
  const { mutate: deleteVolumeAndCost } = useDeleteVolumeAndCost();

  const addVolumeAndCostData = (data: any) => {
    const volumeAndCostData = {
      ...data,
      ownerId: productId,
      sourceId: salesUnitId
    };
    createVolumeAndCost(volumeAndCostData, {
      onSuccess: () => {
        successMessage("Cost and volume recode are created")
        refetch();
      }
    });
  };

  const updateVolumeAndCostData = (data: any) => {
    const volumeAndCostData = {
      ...data,
      ownerId: productId,
      sourceId: salesUnitId
    };
    updateVolumeAndCost(volumeAndCostData, {
      onSuccess: () => {
        refetch();
      }
    });
  };

  const deleteVolumeAndCostData = (volumeAndCostId: string) => {
    deleteVolumeAndCost(volumeAndCostId, {
      onSuccess: () => {
        refetch();
        successMessage("Volume and cost delete successfully");
      }
    });
  };

  //loading view
  if (isLoading) {
    return (
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    );
  }

  return (
    <VolumeAndCost
      volumeAndCost={volumeAndCost}
      addVolumeAndCostData={addVolumeAndCostData}
      updateVolumeAndCostData={updateVolumeAndCostData}
      deleteVolumeAndCostData={deleteVolumeAndCostData}
      unitSize={unitSize}
      unitType={unitType}
    />
  );
};

export default ProductVolumeAndCost;
